const en = {
  sinObra: "No job",
  cat: { materiales: "Materials", mano_obra: "Labour", subcontratas: "Subcontractors", suministros: "Utilities", fiscal: "Tax / Duties" },
  rama: {
    albanil_oficial: "Skilled bricklayer", fontanero: "Plumber", electricista: "Electrician", carpinteria_madera: "Woodwork",
    carpintero_aluminio: "Aluminium joiner", gestion_residuos: "Waste management", transportes: "Transport",
    peones: "Labourers / Helpers", gestiones_comerciales: "Sales & admin tasks",
  },
  exento: { si: "Exempt", marcar: "Mark as exempt", marcado: "Expense marked as exempt", quitado: "Exempt mark removed", error: "Could not update the expense" },
  toast: {
    subida: "Image uploaded", leyendo: "Image uploaded · reading the invoice data…", leidos: "Invoice data read automatically ✨",
    noLeidos: "We couldn't read the data automatically. Please fill it in by hand.", errorSubir: "Could not upload the image",
    registrado: "Expense saved", eliminado: "Expense deleted",
  },
  jornada: {
    titulo: "Working hours per job ({{n}}h/week limit)", totales: "{{n}}h in total",
    excesoObras: "{{n}} job(s)", excesoTexto: "exceed {{n}}h of labour per week. Review the workload.",
    vacio: "No labour hours recorded yet. Add an expense in the «Labour» category with the job and the hours.",
    semExcedidas: "{{n}} week(s) over", resumen: "{{h}}h · {{n}} week(s)", excesoSemana: "{{h}}h over the {{n}}h legal limit.",
  },
  coste: { titulo: "Cost per job", ver: "View Jobs / Projects →", obra: "Job", materiales: "Materials", manoObra: "Labour", total: "Total cost" },
  vacio: { titulo: "No expenses", hint: "Record invoices for materials, labour and subcontractors" },
  tabla: { concepto: "Description", categoria: "Category", fecha: "Date", horas: "Hours", total: "Total", justificante: "receipt", justificanteM: "Receipt" },
  form: {
    escanea: "Scan your invoice and we fill in the details", quitar: "Remove image", leyendo: "Reading…", camara: "Scan with camera",
    subir: "Upload file", analizando: "Analysing image…",
    ocrBloqueado: "You can attach the image; automatic AI reading is available from the Quarterly plan.",
    concepto: "Description", categoria: "Category", proveedor: "Supplier / Company", base: "Net amount (€)", impuesto: "Tax",
    obra: "Job / Project", irpf: "IRPF withholding (professionals)", sinRetencion: "No withholding",
    isp: "Reverse charge", ispNota: "(construction subcontractor invoicing you without VAT or IGIC)",
    exento: "Tax exempt", exentoNota: "(insurance, fees, home rental…)",
    horas: "Hours", rama: "Trade", datosFactura: "Invoice details", numero: "Invoice no.", hora: "Purchase time",
    nif: "Company NIF / CIF", registro: "Companies register no.", opcional: "Optional", fecha: "Date",
  },
};

export default en;
